module.exports = __webpack_public_path__ + "static/una_vita_di_vino-b607c6df478dd1ebf3810bde0c0a80ad.png";